<div class="column">
  <h2 mat-dialog-title>{{"login.lookup_customer_id.title" | transloco}}</h2>

  <mat-dialog-content class="column-gap">
    <mat-form-field hideRequiredMarker="true">
      <mat-label>{{ "login.migrate_admin.label.calit_customer_key" | transloco }}</mat-label>
      <input [formControl]="customerKeyFormControl" matInput />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="close()" mat-button>{{"button.cancel" | transloco}}</button>
    <button (click)="lookupCustomerId()" mat-flat-button>{{"login.lookup_customer_id.button" | transloco}}</button>
  </mat-dialog-actions>
</div>
